/**
 * Provide convenient API for Prime Launcher.
 * Use abstract data provider for data retrieving and handle it for Prime Launcher purposes.
 *
 * @module launcher.api.provider
 */

/* eslint max-lines-per-function: off */

'use strict';

var RESOLUTION   = screen.height,
    pluginFS     = core.plugins.fs,
    uniqueItemID = 1,
    resources    = {
        FAVORITES: 1,
        SAMBA:     20,
        NFS:       30,
        UPNP:      40
    };


/**
 * Open content item (mounted storage or shortcut) via sending intent to application.
 *
 * @param {number|null} resource - resource type to open, if `null` -- open application itself
 * @param {Object} [data] - additional specific data for resource, e.g. flash drive's serial number
 */
function openContentItem ( resource, data ) {
    var intentData = {
            action: 'explorer:openResource',
            data: {
                resource: resource
            },
            events: {}
        },
        property;

    if ( data ) {
        for ( property in data ) {
            intentData.data[property] = data[property];
        }
    }

    core.intent(intentData, function ( error ) {
        if ( error ) {
            console.log(error);
        }
    });
}


module.exports = function ( config, callback ) {
    var gettextWrapper = require('mag-gettext');

    gettextWrapper.load({
        name: core.environment.language,
        path: config.path + 'lang'
    }, function () {
        var Emitter             = require('cjs-emitter'),
            evalStorageCapacity = require('./utils/eval.space'),
            _                   = gettextWrapper.gettext,
            contentProvider     = new Emitter(),
            launcherAPI         = config.api,
            layout              = launcherAPI.layouts.static,
            geometry            = launcherAPI.geometry.horizontal,
            setup               = {
                // how many storages send to Leanback Launcher (max)
                storageItemsAmount: 6,
                shortcuts: [
                    {
                        id:       ++uniqueItemID,
                        layout:   layout,
                        geometry: geometry,
                        data: {
                            name: _('Favorites'),
                            icon: {
                                normal: config.path + 'img/' + RESOLUTION + '/favorites.normal.png',
                                active: config.path + 'img/' + RESOLUTION + '/favorites.active.png'
                            }
                        },
                        onClick: function () {
                            openContentItem(resources.FAVORITES);
                        }
                    },
                    {
                        id:       ++uniqueItemID,
                        layout:   layout,
                        geometry: geometry,
                        data: {
                            name: 'SAMBA',
                            icon: {
                                normal: config.path + 'img/' + RESOLUTION + '/smb.nfs.normal.png',
                                active: config.path + 'img/' + RESOLUTION + '/smb.nfs.active.png'
                            }
                        },
                        onClick: function () {
                            openContentItem(resources.SAMBA);
                        }
                    },
                    {
                        id:       ++uniqueItemID,
                        layout:   layout,
                        geometry: geometry,
                        data: {
                            name: 'NFS',
                            icon: {
                                normal: config.path + 'img/' + RESOLUTION + '/smb.nfs.normal.png',
                                active: config.path + 'img/' + RESOLUTION + '/smb.nfs.active.png'
                            }
                        },
                        onClick: function () {
                            openContentItem(resources.NFS);
                        }
                    },
                    {
                        id:       ++uniqueItemID,
                        layout:   layout,
                        geometry: geometry,
                        data: {
                            name: 'UPnP',
                            icon: {
                                normal: config.path + 'img/' + RESOLUTION + '/upnp.normal.png',
                                active: config.path + 'img/' + RESOLUTION + '/upnp.active.png'
                            }
                        },
                        onClick: function () {
                            openContentItem(resources.UPNP);
                        }
                    }
                ]
                /*moreButton: {
                    id:       ++uniqueItemID,
                    layout:   layout,
                    geometry: geometry,
                    data: {
                        name: _('See more'),
                        icon: {
                            normal: config.path + 'img/' + RESOLUTION + '/see.more.normal.png',
                            active: config.path + 'img/' + RESOLUTION + '/see.more.active.png'
                        }
                    },
                    onClick: function () {
                        openContentItem(null);
                    }
                }*/
            };


        /* backlog functionality
        /**
         * Content search.
         *
         * @param {Object} config configuration for search
         * @param {string} config.query query search request
         * @param {function} callback which called when content is ready
         *\/
        contentProvider.search = function ( config, callback ) {
            // TODO: query data and invoke `callback(error, ContentItem[]);`
        };
        */


        // invoke the basic FS plugin method for gathering information and listening mount events
        pluginFS.onAppInit({}, function ( error, fs ) {
            var getSwitchedStorageItem, storages, storageHeap;

            if ( error ) {
                console.log(error);
            }

            if ( fs ) {
                storages = [];
                storageHeap = {};

                /* eslint no-loop-func:      off */
                /* eslint consistent-return: off */

                /**
                 * Add new content item or delete existent one.
                 *
                 * @param {boolean} state - mount/unmount event flag
                 *
                 * @return {Object} item with switched state
                 */
                getSwitchedStorageItem = function ( state ) {
                    var mountPoints = fs.getMountPoints(),
                        index, item, tmp;

                    for ( index = 0; index < [Object.keys(storageHeap), mountPoints][+state].length; index += 1 ) {
                        item = [Object.keys(storageHeap), mountPoints][+state][index];

                        if ( state ) {
                            if ( !storageHeap[item.sn] ) {
                                storageHeap[item.sn] = {
                                    id:       ++uniqueItemID,
                                    index:    storages.length,
                                    layout:   layout,
                                    geometry: geometry,
                                    data: {
                                        name:       item.label || item.vendor || item.model,
                                        isReadOnly: item.isReadOnly,
                                        capacity:   evalStorageCapacity(item.freeSize) + ' / ' + evalStorageCapacity(item.size),
                                        icon: {
                                            normal: config.path + 'img/' + RESOLUTION + '/usb.normal.png',
                                            active: config.path + 'img/' + RESOLUTION + '/usb.active.png'
                                        }
                                    },
                                    onClick: function () {
                                        openContentItem(null, {serialNumber: item.sn});
                                    }
                                };

                                storages.push(storageHeap[item.sn]);

                                return storageHeap[item.sn];
                            }
                        } else if ( !mountPoints.some(function ( mountPoint ) { return mountPoint[item]; }) ) { // eslint-disable-line
                            tmp = storageHeap[item];

                            storages.splice(storages.indexOf(tmp), 1);
                            delete storageHeap[item];

                            return tmp;
                        }
                    }
                };


                /**
                 * Callback for mount/unmount event.
                 *
                 * @param {boolean} state - mount/unmount storage
                 */
                fs.onMount = function ( state ) {
                    if ( state && storages.length + 1 === setup.storageItemsAmount ) {
                        // possibly show notification for this case with suggestion to go to the Explorer
                        return;
                    }

                    contentProvider.emit(['remove', 'add'][+state], getSwitchedStorageItem(state));
                };


                fs.getMountPoints()
                    .slice(0, setup.storageItemsAmount)
                    .forEach(function ( item ) {
                        storageHeap[item.sn] = {
                            id:       ++uniqueItemID,
                            layout:   layout,
                            geometry: geometry,
                            data: {
                                name:       item.label || item.vendor || item.model,
                                isReadOnly: item.isReadOnly,
                                capacity:   evalStorageCapacity(item.freeSize) + ' / ' + evalStorageCapacity(item.size),
                                icon: {
                                    normal: config.path + 'img/' + RESOLUTION + '/usb.normal.png',
                                    active: config.path + 'img/' + RESOLUTION + '/usb.active.png'
                                }
                            },
                            onClick: function () {
                                openContentItem(null, {serialNumber: item.sn});
                            }
                        };

                        storages.push(storageHeap[item.sn]);
                    });

                callback(null, {
                    provider: contentProvider,
                    data:     storages.concat(setup.shortcuts/*, setup.moreButton*/)
                });
            } else {
                // information from FS plugin is unavailable
                callback(null, {
                    provider: contentProvider,
                    data:     setup.shortcuts/*.concat(setup.moreButton)*/
                });
            }
        });
    });
};
